import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { FormControl, Typography, Box, Button, InputLabel, Select, MenuItem, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { Form, Formik, FormikHelpers } from 'formik';
import { useTranslation } from 'react-i18next';
import CustomSelect from '../../Components/CustomSelect';
import CustomTextField from '../../Components/CustomTextFIeld/idex';
import Utils from './utils';
import { useAddCarsMutation } from '../../store/services/cars';
import Callery from './Gallery';
import { useAppDispatch, useAppSelector } from '../../store';
import { useGetMarkQuery, useGetModelQuery } from '../../store/services/markmodel';
import { IModel } from '../../types';
import { setImages } from '../../store/slices/images';

function Carpage() {
  const {

    SignupSchema,
    generateDate,
    navigate
  } = Utils();
  const { t, i18n } = useTranslation();
  const [model, setModel] = useState<number>();
  const [addCars, { error, isSuccess }] = useAddCarsMutation();
  const [mainImageId, setMainImageId]=useState<number | null>(null);
  const { data: dataModel, isLoading: isLoadingModel } = useGetModelQuery({ limit: 1000000 });
  const { data: dataMark, isLoading: isLoadingMark } = useGetMarkQuery({ modelId: model, limit: 1000000 });
  const images = useAppSelector((state) => state.images.images);
  const dispatch = useAppDispatch();

  interface Values {
    "location": any,
    "vin": any,
    "marksId": any,
    "year": any,
    "mileage": any,
    "mileageType": any,
    "colorArm": any,
    "colorRu": any,
    "colorEn": any,
    "engineVolume": any,
    // "driveType": any,
    "price": any,
    "descriptionArm": any,
    "descriptionRu": any,
    "descriptionEn": any,
    "transmission":any,
    "body":any,
    "wheel":any
  }
  const errorToast = (err: any) => toast.error(err ? err.error : 'someting went wrong');
  useEffect(() => {
    if (error) {
      errorToast(error);
    }
  }, [error])
  const handleSelectMark = (el: number) => {
    setModel(el)
  }
  useEffect(() => {
    return function cleanup() {
      dispatch(setImages([]))
    };
  }, []);
  useEffect(()=>{
    if (isSuccess) navigate('/cars')
  },[isSuccess])
  return <>

    <Box>
      <Typography gutterBottom variant="h5" component="div">
        {t('create')}
      </Typography>
      <Box >
      <Callery selectMainImage={(id)=>setMainImageId(id)} selectMainImageId={mainImageId}/>
      <Box className='responsive-form' sx={{ gap: 3, width: '60%' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Formik
            initialValues={{
              "location": "",
              "vin": "",
              "marksId": null,
              "year": null,
              "mileage": null,
              "mileageType": "mile",
              "colorArm": "",
              "colorRu": "",
              "colorEn": "",
              "engineVolume": null,
              // "driveType": "",
              "price": null,
              "descriptionArm": "",
              "descriptionRu": null,
              "descriptionEn": null,
              "transmission":null,
              "body":'',
              "wheel":null
            }}
            validationSchema={SignupSchema}
            onSubmit={(
              values: Values,
              { setSubmitting }: FormikHelpers<Values>
            ) => {
              try {
                addCars({ ...values, driveType:"front_wheel_drive", mainImageId,images: images.map((el) => el.id) })
              } catch (error: any) {
                errorToast(error.message)
              }

            }}
          >
            {({ errors, touched, handleChange }: any) => (
              <Form >
                {!isLoadingModel && <Box sx={{ maxWidth: 200, mb: 2 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">{t('mark')}</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={model}
                      onChange={(el: any) => handleSelectMark(el.target.value)}
                      label={t('mark')}
                    >
                      {dataModel?.result?.map((el: IModel) => <MenuItem key={el.id} value={el.id}>{el.name}</MenuItem>)}
                    </Select>
                  </FormControl>
                </Box>}
                {!isLoadingMark && <Box sx={{ maxWidth: 200, mb: 2 }}>
                  <FormControl fullWidth><CustomSelect
                    name='marksId'
                    label={t('model')}
                    list={dataMark?.result.filter((el) => el.model_id === model)}
                  /></FormControl>

                </Box>}

                <Box sx={{ maxWidth: 200, mb: 2 }}>
                  <FormControl fullWidth><CustomSelect
                    name='year'
                    label={t('date')}
                    list={generateDate()?.map((el) => ({ name: el, id: el }))}
                  /></FormControl>
                </Box>
                <Box sx={{ maxWidth: 200, mb: 2 }}>
                  <FormControl fullWidth>
                    <CustomTextField name='price' label={t('price')} variant="outlined" type='number' />
                  </FormControl>
                </Box>
                <Box sx={{ minWidth: 200, mb: 2 }}>
                  <FormControl fullWidth>
                    <CustomTextField name='descriptionArm' label={t('descriptionArm')} variant="outlined" />
                  </FormControl>
                </Box>
                <Box sx={{ minWidth: 200, mb: 2 }}>
                  <FormControl fullWidth>
                    <CustomTextField name='descriptionRu' label={t('descriptionRu')} variant="outlined" />
                  </FormControl>
                </Box>
                <Box sx={{ minWidth: 200, mb: 2 }}>
                  <FormControl fullWidth>
                    <CustomTextField name='descriptionEn' label={t('descriptionEn')} variant="outlined" />
                  </FormControl>
                </Box>
                <Box sx={{ minWidth: 200, mb: 2 }}>
                  <FormControl fullWidth>
                    <CustomTextField name='colorArm' label={t('colorArm')} variant="outlined" />
                  </FormControl>
                </Box>
                <Box sx={{ minWidth: 200, mb: 2 }}>
                  <FormControl fullWidth>
                    <CustomTextField name='colorRu' label={t('colorRu')} variant="outlined" />
                  </FormControl>
                </Box>
                <Box sx={{ minWidth: 200, mb: 2 }}>
                  <FormControl fullWidth>
                    <CustomTextField name='colorEn' label={t('colorEn')} variant="outlined" />
                  </FormControl>
                </Box>
                <Box sx={{ minWidth: 200, mb: 2 }}>
                  <FormControl fullWidth>
                    <CustomTextField name='engineVolume' label={t('engineVolume')} variant="outlined" type='number' />
                  </FormControl>
                </Box>
                <Box sx={{ minWidth: 200, mb: 2, display: 'flex', alignItems: 'center' }}>
                  <RadioGroup
                    name="mileageType"
                    onChange={handleChange}
                    defaultValue='mile'
                  >
                    <FormControlLabel value="mile" control={<Radio />} label="Mile" />
                    <FormControlLabel value="km" control={<Radio />} label="Km" />
                  </RadioGroup>
                  <Box sx={{ minWidth: 100, mb: 2 }}>
                    <FormControl fullWidth>
                      <CustomTextField name='mileage' label={t('mileage')} type='number' variant="outlined" />
                    </FormControl>
                  </Box>
                </Box>
                <Box sx={{ minWidth: 200, mb: 2 }}>
                  <FormControl fullWidth>
                    <CustomSelect
                      name='wheel'
                      label={t('wheel')}
                      list={[
                        { name: t('right'), id: 'right' },
                        { name: t('left'), id: 'left' },
                      ]}
                    />
                  </FormControl>
                </Box>
                <Box sx={{ minWidth: 200, mb: 2 }}>
                  <FormControl fullWidth>
                    <CustomSelect
                      name='transmission'
                      label={t('transmission')}
                      list={[
                        { name: t('mechanical'), id: 'mechanical' },
                        { name: t('automatic'), id: 'automatic' },
                      ]}
                    />
                  </FormControl>
                </Box>
                <Box sx={{ minWidth: 200, mb: 2 }}>
                  <FormControl fullWidth>
                    <CustomSelect
                      name='engineType'
                      label={t('engineType')}
                      list={[
                        { name: t('gasoline'), id: 'gasoline' },
                        { name: t('hybrid'), id: 'hybrid' },
                        { name: t('diesel'), id: 'diesel' },
                        { name: t('electric'), id: 'electric' },
                      ]}
                    />
                  </FormControl>
                </Box>
                <Box sx={{ minWidth: 200, mb: 2 }}>
                  <FormControl fullWidth>
                    <CustomSelect
                      name='body'
                      label={t('body')}
                      list={[
                        { name: t('sedan'), id: 'sedan' },
                        { name: t('suv'), id: 'suv' },
                        { name: t('bigSuv'), id: 'big_suv' },
                        { name: t('pickup'), id: 'pickup' },
                        { name: t('motorcycle'), id: 'motorcycle' },
                        { name: t('miniven'), id: 'miniven' },
                      ]}
                    />
                  </FormControl>
                </Box>
                {/* <Box sx={{ minWidth: 200, mb: 2 }}>
                  <FormControl fullWidth>
                    <CustomSelect
                      name='driveType'
                      label={t('driveType')}
                      list={[
                        { name: 'front wheel drive', id: 'front wheel drive' },
                        { name: 'rear drive', id: 'rear drive' },
                        { name: 'all wheel drive', is: 'all wheel drive' }]}
                    />
                  </FormControl>
                </Box> */}
                <Box sx={{ minWidth: 200, mb: 2 }}>
                  <FormControl fullWidth>
                    <CustomSelect
                      name='location'
                      label={t('location')}
                      list={[{ name: 'In the auction', id: 'in_the_auction' }, { name: 'on the way', id: 'on_the_way' }, { name: 'in Armenia', id: 'in_armenia' }]}
                    />
                  </FormControl>
                </Box>
                <Box sx={{ minWidth: 200, mb: 2 }}>
                  <FormControl fullWidth>
                    <CustomTextField name='vin' label='vin' variant="outlined" />
                  </FormControl>
                </Box>
                <Button type='submit' variant="contained">{t('create')}</Button>
              </Form>
            )}
          </Formik>
        </Box>
      </Box>
      </Box>
    </Box>
  </>
}
export default Carpage;